import React from 'react';

import { flagStyles } from '../settings';

const SvgCM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1080px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCM;
